var exports = {
  "Qs": "BanMemberModal.module__content___ZHVlb3",
  "Ki": "BanMemberModal.module__video___ZHVlb3",
  "Gf": "BanMemberModal.module__sectionTitle___ZHVlb3",
};

module.exports = exports;
